import { render } from "./index.vue?vue&type=template&id=02ddb402"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=02ddb402&lang=less"

import exportComponent from "/data/spug/spug_api/repos/34_1470_20220520214630/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__